// extracted by mini-css-extract-plugin
module.exports = {"Title":"AYrzW","Catalog":"_6VXsN","Content":"pekvw"};